

export default {
  name: 'RejectNoticeOfPrivacy',
  computed: {
    tablet() {
      return this.$q.screen.lt.lg && this.$q.screen.gt.sm;
    },
    mobile() {
      return this.$q.screen.lt.md;
    },
  },
};
